export default "__VITE_ASSET__wHZHk_0H__"